<template>
  <div>
    <div v-if="allCheckbox" :class="[...allCheckbox.class]">
      <gj-checkbox
          v-model="checkAll"
          name="allCheckbox"
          :indeterminate="indeterminate"
          @change="handleCheckAllChange">
        {{allCheckbox.label}}
      </gj-checkbox>
    </div>
    <el-checkbox-group
        v-bind="$attrs"
        v-on="$listeners"
        :value="value"
        @input="onInput($event)">
      <slot></slot>
    </el-checkbox-group>
  </div>
</template>

<script>
  import {isMeaningful} from "../../utils/common";

  export default {
    name: "gj-checkbox-group",
    props: {
      value: {
        type: Array
      },
      allCheckbox: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        checkAll: false,
        indeterminate: false,
        checkboxArr: [],
        checkboxValueArr: [],
        checkboxDisabledValueArr: []
      }
    },
    created() {
    },
    mounted() {
      this.checkboxArr = getAllCheckbox(this.$children);
      this.checkboxValueArr = this.checkboxArr.map(e => {
        if (isMeaningful(e.$attrs.label)) {
          return e.$attrs.label;
        } else if (isMeaningful(e.$attrs.value)) {
          return e.$attrs.value;
        }
        return null;
      });
      this.checkboxDisabledValueArr = this.checkboxArr.filter(e => e.$attrs.disabled).map(e => {
        if (isMeaningful(e.$attrs.label)) {
          return e.$attrs.label;
        } else if (isMeaningful(e.$attrs.value)) {
          return e.$attrs.value;
        }
        return null;
      });
      this.onInput(this.value);
    },
    methods: {
      onInput(valueArr) {
        this.checkAll = this.checkboxValueArr.every(value => valueArr.includes(value));
        this.indeterminate = !this.checkAll && this.checkboxValueArr.some(value => valueArr.includes(value));
        this.$emit('input', valueArr);
      },
      handleCheckAllChange(check) {
        if (check) {
          this.indeterminate = false;
          this.$emit('input', this.checkboxValueArr);
        } else {
          this.indeterminate = this.checkboxDisabledValueArr.length > 0;
          this.$emit('input', this.checkboxDisabledValueArr);
        }
      },
    }
  }
  function getAllCheckbox($children) {
    let checkboxArr = [];
    if (isMeaningful($children)) {
      for (let i = 0; i < $children.length; i++) {
        const child = $children[i];
        if (child.$options._componentTag === 'gj-checkbox'
          && child.name !== 'allCheckbox') {
          checkboxArr.push(child);
        }
        if (child.$children) {
          checkboxArr = checkboxArr.concat(getAllCheckbox(child.$children));
        }
      }
    }
    return checkboxArr;
  }
</script>

<style scoped>

</style>
